import { injectGlobal } from 'emotion';

import { Direction } from './';

export namespace animations {
  export const getAnimationStates = (from: Direction) => {
    const initialXTransform = `${from === 'left' ? '-' : ''}5rem`;
    return {
      entering: {
        transform: `translateX(${initialXTransform}) translateZ(.001px)`
      },
      entered: {
        opacity: 1,
        transform: 'translateX(0)'
      },
      exiting: {
        transform: `translateX(${initialXTransform}) translateZ(.001px)`
      },
      exited: {
        opacity: 0
      }
    };
  };
}

const globalAnimations = {};

export type HorizontalSlideTransitions = 'slide-in-left' | 'slide-in-right';

const directions: {
  direction: Direction;
  name: HorizontalSlideTransitions;
}[] = [{ direction: 'left', name: 'slide-in-left' }, { direction: 'right', name: 'slide-in-right' }];

directions.forEach(({ direction, name }) => {
  const animationState = animations.getAnimationStates(direction);

  globalAnimations[`.${name}-enter-active`] = { ...animationState.entering };
  globalAnimations[`.${name}-enter-done`] = {
    ...animationState.entered,
    position: 'relative'
  };
  globalAnimations[`.${name}-exit-active`] = { ...animationState.exiting };
});

injectGlobal(globalAnimations);
